import { render, staticRenderFns } from "./GalleryWithTextAndImage.vue?vue&type=template&id=3d78bcea&scoped=true&"
import script from "./GalleryWithTextAndImage.vue?vue&type=script&lang=ts&"
export * from "./GalleryWithTextAndImage.vue?vue&type=script&lang=ts&"
import style0 from "./GalleryWithTextAndImage.vue?vue&type=style&index=0&id=3d78bcea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d78bcea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d78bcea')) {
      api.createRecord('3d78bcea', component.options)
    } else {
      api.reload('3d78bcea', component.options)
    }
    module.hot.accept("./GalleryWithTextAndImage.vue?vue&type=template&id=3d78bcea&scoped=true&", function () {
      api.rerender('3d78bcea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grid/galleryWithTextAndImage/GalleryWithTextAndImage.vue"
export default component.exports